import { render, staticRenderFns } from "./qualityReportUpload.vue?vue&type=template&id=58d5413e&scoped=true"
import script from "./qualityReportUpload.vue?vue&type=script&lang=js"
export * from "./qualityReportUpload.vue?vue&type=script&lang=js"
import style0 from "./qualityReportUpload.vue?vue&type=style&index=0&id=58d5413e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5413e",
  null
  
)

export default component.exports